import { api } from './client';
import { ZoneNode } from '../utils/zoneUtils'; // Assuming this exists based on DashboardHome.tsx

export interface Subscription {
    subscriptionId: string;
    zipCodes: string[];
    enabled: boolean;
    filters?: {
        minRent?: number;
        maxRent?: number;
        minRooms?: number;
        maxRooms?: number;
        minSpace?: number;
        maxSpace?: number;
        wbsFilter?: 'ANY' | 'ONLY' | 'NONE';
        wgFilter?: 'ANY' | 'ONLY' | 'NONE';
        swapFilter?: 'ANY' | 'ONLY' | 'NONE';
        tempFilter?: 'ANY' | 'ONLY' | 'NONE';
        providerFilter?: 'ANY' | 'COMMERCIAL' | 'PRIVATE';
        furnishedFilter?: 'ANY' | 'ONLY' | 'NONE';
        closedAreaFilter?: 'ANY' | 'ONLY' | 'NONE';
    };
    notificationTargets?: {
        telegram?: {
            chatId: number;
            chatTitle?: string;
            chatType?: string;
        };
    };
    uiMetadata?: {
        zones: ZoneNode[];
        originalTelegramGroup?: {
            chatTitle: string;
            chatType?: string;
        };
    };
    createdAt: string;
    expiresAt?: number | null;
    notificationChannels?: string[]; // Raw channels from API
}

export const getSubscriptions = async (userId: string): Promise<Subscription[]> => {
    const response = await api.get(`/subscription?userId=${userId}`);
    // Defensive client-side filtering: exclude soft-deleted rows if server returns them.
    const subs = response.data.subscriptions || [];
    return subs.filter((s: any) => !(s.deleted === true));
};

export const getSubscription = async (id: string): Promise<Subscription> => {
    const response = await api.get(`/subscription/${id}`);
    return response.data;
};

export const getAllSubscriptions = async (): Promise<Subscription[]> => {
    // Adjusted to match singular resource pattern
    const response = await api.get('/subscription');
    const subs = response.data || [];
    return subs.filter((s: any) => !(s.deleted === true));
};

export const createSubscription = async (data: any) => {
    const response = await api.post('/subscription', data);
    return response.data;
};

export const updateSubscription = async (id: string, data: any) => {
    const response = await api.put(`/subscription/${id}`, data);
    return response.data;
};

export const deleteSubscription = async (id: string) => {
    await api.delete(`/subscription/${id}`);
};

export const updateSubscriptionStatus = async (id: string, enabled: boolean) => {
    const response = await api.put(`/subscription/${id}`, { enabled });
    return response.data;
};
